import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import {
    FaPlus, FaEdit, FaTrash, FaBoxOpen,
    FaCheckCircle, FaTimesCircle, FaArrowRight,
    FaSearch, FaFilter, FaLayerGroup
} from "react-icons/fa";

export default function PriceSurveyProductsPage() {
    const { backEnd_request } = BackMethods();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]); // لتخزين التصنيفات

    // حالات التصفية والبحث
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");

    // حالات المودال
    const [showModal, setShowModal] = useState(false);
    const [currentProduct, setCurrentProduct] = useState({ name: "", categoryId: "", isActive: true });
    const [isEdit, setIsEdit] = useState(false);

    // تحميل المنتجات
    const loadProducts = async () => {
        setLoading(true);
        try {
            const response = await backEnd_request.get("/PriceSurveyProducts");
            setProducts(response.data);
        } catch (err) { console.error(err); }
        finally { setLoading(false); }
    };

    // تحميل التصنيفات (للقائمة المنسدلة)
    const loadCategories = async () => {
        try {
            const response = await backEnd_request.get("/PriceSurveyProductCategories");
            setCategories(response.data);
        } catch (err) { console.error("خطأ في جلب التصنيفات", err); }
    };

    useEffect(() => {
        loadProducts();
        loadCategories();
    }, []);

    // --- منطق الفلترة والبحث ---
    const filteredProducts = products.filter(item => {
        const matchesSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (item.categoryName && item.categoryName.toLowerCase().includes(searchTerm.toLowerCase()));

        const matchesStatus = statusFilter === "all" ? true :
            statusFilter === "active" ? item.isActive === true :
                item.isActive === false;

        return matchesSearch && matchesStatus;
    });

    const handleDelete = async (id) => {
        if (window.confirm("هل أنت متأكد من حذف هذا المنتج؟")) {
            try {
                await backEnd_request.delete(`/PriceSurveyProducts/${id}`);
                setProducts(products.filter(p => p.priceSurveyProductId !== id));
            } catch (err) { alert("حدث خطأ أثناء الحذف"); }
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!currentProduct.categoryId) {
            alert("يرجى اختيار التصنيف");
            return;
        }
        try {
            if (isEdit) {
                await backEnd_request.post(`/PriceSurveyProducts/${currentProduct.priceSurveyProductId}`, currentProduct);
            } else {
                await backEnd_request.post("/PriceSurveyProducts", currentProduct);
            }
            setShowModal(false);
            loadProducts();
            setCurrentProduct({ name: "", categoryId: "", isActive: true });
        } catch (err) { alert("خطأ في الحفظ"); }
    };

    return (
        <div className="bg-light min-vh-100 py-4" dir="rtl">
            <div className="container shadow-sm bg-white rounded-4 p-4">

                {/* الرأس - Header */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 pb-3 border-bottom gap-3">
                    <div>
                        <h3 className="fw-bold text-primary mb-1">
                            <FaBoxOpen className="ms-2" /> منتجات مسح الأسعار
                        </h3>
                        <p className="text-muted small mb-0">إجمالي المنتجات: {filteredProducts.length}</p>
                    </div>
                    <div className="d-flex gap-2">
                        <button
                            onClick={() => { setIsEdit(false); setCurrentProduct({ name: "", categoryId: "", isActive: true }); setShowModal(true); }}
                            className="btn btn-primary d-flex align-items-center px-4 rounded-pill shadow-sm"
                        >
                            <FaPlus className="ms-2" /> إضافة منتج
                        </button>
                        <button onClick={() => navigate(-1)} className="btn btn-outline-secondary rounded-pill">
                            <FaArrowRight className="ms-1" /> رجوع
                        </button>
                    </div>
                </div>

                {/* قسم التصفية والبحث */}
                <div className="row g-3 mb-4 bg-light p-3 rounded-3 border">
                    <div className="col-md-8">
                        <div className="input-group border rounded-pill bg-white px-3 py-1">
                            <span className="input-group-text bg-transparent border-0 text-muted"><FaSearch /></span>
                            <input
                                type="text"
                                className="form-control border-0 bg-transparent shadow-none"
                                placeholder="ابحث باسم المنتج أو التصنيف..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="input-group border rounded-pill bg-white px-3 py-1">
                            <span className="input-group-text bg-transparent border-0 text-muted"><FaFilter /></span>
                            <select
                                className="form-select border-0 bg-transparent shadow-none"
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                            >
                                <option value="all">جميع الحالات</option>
                                <option value="active">نشط فقط</option>
                                <option value="inactive">متوقف فقط</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* عرض الجدول */}
                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-hover align-middle border-light">
                            <thead className="table-light">
                                <tr>
                                    <th className="py-3 border-0">اسم المنتج</th>
                                    <th className="py-3 border-0">التصنيف</th>
                                    <th className="py-3 border-0 text-center">الحالة</th>
                                    <th className="py-3 border-0 text-center">إجراءات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredProducts.map((item) => (
                                    <tr key={item.priceSurveyProductId}>
                                        <td className="fw-bold text-dark py-3">{item.name}</td>
                                        <td>
                                            <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 rounded-pill fw-normal">
                                                <FaLayerGroup className="ms-1" /> {item.categoryName || "غير مصنف"}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            {item.isActive ? (
                                                <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2 rounded-pill fw-normal">
                                                    <FaCheckCircle className="ms-1" /> نشط
                                                </span>
                                            ) : (
                                                <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-2 rounded-pill fw-normal">
                                                    <FaTimesCircle className="ms-1" /> متوقف
                                                </span>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            <div className="btn-group shadow-sm bg-white rounded-3">
                                                <button
                                                    onClick={() => { setCurrentProduct(item); setIsEdit(true); setShowModal(true); }}
                                                    className="btn btn-outline-primary btn-sm border-0 px-3"
                                                >
                                                    <FaEdit />
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(item.priceSurveyProductId)}
                                                    className="btn btn-outline-danger btn-sm border-0 px-3"
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Modal - إضافة وتعديل المنتج */}
            {showModal && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(4px)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg rounded-4">
                            <div className="modal-header border-0 pt-4 px-4">
                                <h5 className="fw-bold">{isEdit ? "تعديل المنتج" : "إضافة منتج جديد"}</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <form onSubmit={handleSave}>
                                <div className="modal-body p-4">
                                    <div className="mb-3">
                                        <label className="form-label small fw-bold">اسم المنتج</label>
                                        <input
                                            type="text" className="form-control rounded-3"
                                            value={currentProduct.name}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, name: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label small fw-bold">تصنيف المادة</label>
                                        <select
                                            className="form-select rounded-3"
                                            value={currentProduct.categoryId}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, categoryId: e.target.value })}
                                            required
                                        >
                                            <option value="">اختر التصنيف...</option>
                                            {categories.map(cat => (
                                                <option key={cat.categoryId} value={cat.categoryId}>
                                                    {cat.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-check form-switch mt-3">
                                        <input
                                            className="form-check-input" type="checkbox"
                                            checked={currentProduct.isActive}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, isActive: e.target.checked })}
                                        />
                                        <label className="form-check-label fw-bold small">تفعيل المنتج في النظام</label>
                                    </div>
                                </div>
                                <div className="modal-footer border-0 p-4 pt-0">
                                    <button type="button" className="btn btn-light rounded-3 px-4" onClick={() => setShowModal(false)}>إغلاق</button>
                                    <button type="submit" className="btn btn-primary rounded-3 px-4">حفظ</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}